import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useShopQuery } from '../generated/graphql'
import { ShopSection1, ShopSection2 } from '../components/shop-section'
import { ShopYutai } from '../components/shop-yutai'
import { ShopMessage } from '../components/shop-message'
import { ShopContact } from '../components/shop-contact'
import { ShopDetailButton } from '../components/shop-detail-button'
import { ShopInfo } from '../components/shop-info'

const Outer = styled.div``

type ShopContentSectionProps = {

}
export const ShopContentSection: FunctionComponent<ShopContentSectionProps> = () => {
  const shopQuery = useShopQuery({
    variables: {
      slug: location.pathname.match(/(?<=\/).*$/)?.[0] ?? ''
    }
  })
  const shop = shopQuery.data?.shop
  if(!shop) return null

  return <Outer>
    {shop.shopFields?.contents?.map((content, i) => {
      switch(content?.__typename){
        case 'ShopFieldsContentsSection1Layout':
          return <ShopSection1 data={content} />
        case 'ShopFieldsContentsSection2Layout':
          return <ShopSection2 data={content} />
        case 'ShopFieldsContentsBenefitSectionLayout':
          return <ShopYutai data={content} />
        case 'ShopFieldsContentsMessageLayout':
          return <ShopMessage data={content} />
        case 'ShopFieldsContentsContactLayout':
          return <ShopContact data={content} />
        case 'ShopFieldsContentsDetailButtonLayout':
          return <ShopDetailButton data={content} />
        case 'ShopFieldsContentsShopInfoLayout':
          return <ShopInfo data={content} />
        default:
          return null
      }
    })}
  </Outer>
}